<template>
    <div class="coming-soon-area">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="coming-soon-content">
                    <router-link to="/" class="logo">
                        <!-- <img src="../../assets/img/logo.png" alt="image"> -->
                        <h2>
                            أساكيب الجديد
                        </h2>
                        <br>
                    </router-link>
                    <h3 class="fs-22">إصدار الخدمات التعليمية المتكاملة لمنصة أساكيب </h3>
                    <h5 class="fs-18">
                        موعدنا: 1 سبتمبر 2025
                        إن شاء الله
                    </h5>
                    <div id="timer" class="flex-wrap d-flex justify-content-center">
                        <div id="days" class="align-items-center flex-column d-flex justify-content-center">
                            <h3>{{ days }}</h3>
                            <p>أيام</p>
                        </div>
                        <div id="hours" class="align-items-center flex-column d-flex justify-content-center">
                            <h3>{{ hours }}</h3>
                            <p>ساعات</p>
                        </div>
                        <div id="minutes" class="align-items-center flex-column d-flex justify-content-center">
                            <h3>{{ minutes }}</h3>
                            <p>دقيقة</p>
                        </div>
                        <div id="seconds" class="align-items-center flex-column d-flex justify-content-center">
                            <h3>{{ seconds }}</h3>
                            <p>ثانية</p>
                        </div>
                    </div>
                    <div class="newsletter-form mt-4">
                        <p>
                            <b>
                                نبشركم بقرب إعادة إطلاق أساكيب في ثوب جديد قشيب؛ لتكون - بحق - المنصة الأولى عربيا
                                وعالميا التي
                                تقدم
                                هذه الخدمات مجتمعة في منصة واحدة
                            </b>
                            <br>
                            <b>
                                خدماتنا ستغنيك عن العديد من المنصات والمواقع المختلفة إن شاء الله
                            </b>
                        </p>
                    </div>
                    <a class="default-btn mt-4" href="https://asakeeb.com">
                        أساكيب الحالي
                        <i class="bx bx-left-arrow-alt pt-2"></i>
                    </a>
                    <!-- <form class="newsletter-form" @submit.prevent="authStore.handleComingSoon(form)">
                        <div class="form-group">
                            <input type="text" v-model="form.email" class="input-newsletter p-2"
                                placeholder="أدخل بريدك الالكتروني" name="EMAIL">
                            <span class="label-title"><i class='bx bx-envelope'></i></span>
                            <p v-if="authStore.authErrors.email" class="text-red">
                                {{ authStore.authErrors.email[0] }}
                            </p>
                            <p v-if="authStore.savingSuccessful" class="text-green">
                                <i class="bx bx-check pt-2"></i>
                                {{ authStore.savingSuccessful }}
                            </p>

                        </div>
                        <button type="submit" class="default-btn">
                            <i class="flaticon-user"></i>
                            تابعنا
                            <span></span>
                        </button>
                        <p>
                            إذا كنت ترغب في تلقي إشعار عندما يصبح أساكيب الجديد جاهزًا، فيرجى الاشتراك في القائمة
                            البريدية
                            الخاصة بنا.
                        </p>
                    </form> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ComingSoonPage',
    data() {
        return {
            days: '',
            hours: '',
            minutes: '',
            seconds: ''
        }
    },
    created() { // Turn data into viewable values
        setInterval(() => {
            this.commingSoonTime();
        }, 1000);
    },
    methods: {
        commingSoonTime() {
            let endTime = new Date("September 1, 2025 09:00:00 PDT");
            let endTimeParse = (Date.parse(endTime)) / 1000;
            let now = new Date();
            let nowParse = (Date.parse(now) / 1000);
            let timeLeft = endTimeParse - nowParse;
            let days = Math.floor(timeLeft / 86400);
            let hours = Math.floor((timeLeft - (days * 86400)) / 3600);
            let minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600)) / 60);
            let seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));
            if (hours < "10") { hours = "0" + hours; }
            if (minutes < "10") { minutes = "0" + minutes; }
            if (seconds < "10") { seconds = "0" + seconds; }
            this.days = days;
            this.hours = hours;
            this.minutes = minutes;
            this.seconds = seconds;
        },
        formSubmit() {
            console.log('form submitted');
        },
    }
}
</script>

<script setup>

import { ref } from 'vue';
import { useAuthStore } from '../../stores/auth';
const authStore = useAuthStore();
const form = ref({
    email: '',
})

</script>